import { render, staticRenderFns } from "./Top20Customers.vue?vue&type=template&id=9412925a&"
import script from "./Top20Customers.vue?vue&type=script&lang=js&"
export * from "./Top20Customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports